<div id="driver-wizard"
     class="row ">
     <div class="overlay"
          *ngIf="isLoading">
          <h1 [innerHtml]="'Loading' | translator:'base'">Loading ...</h1>
          <img alt="Loading" />
     </div>
     <div class="d-flex justify-content-between align-items-center"
          id="page-title">
          <h1 [innerHtml]="'RequestYourRecord' | translator: 'base'">
               Request Your PSP Record
          </h1>
     </div>
     <div class="col-lg-8">
          <div class="card shadow-sm rounded-0 border-0">
               <div class="card-body">
                    <app-complete-bar [step]="11"
                                      [totalSteps]="11"></app-complete-bar>
                    <h2 [innerHtml]="'YourPSPRecord' | translator: 'base'">
                         YOUR PSP RECORD
                    </h2>
                    <p class="text-center"
                       [innerHtml]="'RecordViewOptions' | translator: 'base'">
                         There are two options for viewing your PSP record: HTML (as a web page) or PDF (as a document
                         you can download). View
                         your record by clicking the appropriate button below:
                    </p>
                    <p class="text-center">
                         <span [innerHtml]="'RecordSuccessMVR1' | translator: 'driver'">If you need your motor vehicle record for a specific
                              State click </span>
                         <a class="btn btn-link normal-link" (click)="navigateToStateMVR()" [ariaLabel]="'navbar_mvr_state_dashboard_link' | translator: 'base'"
                              name="stateMVRlink" id="stateMVR" [innerHtml]="'here' | translator: 'base'">here</a>
                         <span [innerHtml]="'RecordSuccessMVR2' | translator: 'driver'"> to access the official Motor Vehicle Record request
                              websites provided by each State.</span>
                    </p>
                    

                    <div class="text-center mb-2">
                         <button class="btn btn-primary btn-strong me-2"
                                 (click)="showInBrowser()"
                                 name="view"
                                 id="view"
                                 [innerHtml]="'View' | translator: 'driver'"
                                 [title]="'View' | translator: 'driver'">
                              View
                         </button>
                         <button class="btn btn-outline-primary me-2"
                                 (click)="downloadPdf()"
                                 name="download"
                                 id="download"
                                 [innerHtml]="'Download' | translator: 'driver'"
                                 [title]="'Download' | translator: 'driver'">
                              Download
                         </button>
                         <button (click)="finish()"
                                 class="btn btn-primary btn-strong"
                                 name="finish"
                                 id="finish"
                                 [innerHtml]="'Finish' | translator: 'base'"
                                 [title]="'Finish' | translator: 'base'">
                              Finish
                         </button>
                    </div>
                    <p 
                         class="text-center"
                         [innerHTML]="'AllowPopUpsMessage' | translator: 'base'"
                    >
                         If you click on the “View” button and nothing displays, make sure your pop-ups are not blocked.
                    </p>
                    <p class="text-center"
                       [innerHtml]="'DownloadAdobePdf' | translator: 'base'">
                         If you need a way to view the PDF document, you can download the free <a
                            href="https://get.adobe.com/reader/"
                            target="_blank"
                            name="Adobe-PDF-Reader">Adobe PDF Reader</a>.
                    </p>

               </div>
          </div>
     </div>
     <app-progress-wizard *ngIf="wizard"
                          [wizardObj]="wizard"
                          [activeStep]="5"
                          pageType="driver"
                          class="col-lg-4 sidebar d-none d-lg-block">
     </app-progress-wizard>
</div>